export default {"src":"/_next/static/media/icon-apeiron-logo-simplified.9443b06e.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};